module.exports = __webpack_public_path__ + "img/paciente.074a43f9.png";